import { uploadFile, getFileById } from '@/api/file/fileApi';
import { saveExtractionIntoReport } from '@/api/pdfApi';
import { INIT_NO_OP_NUM, PDF_FILE_TYPE } from '@/config';
import { setPdf, clearPdf, setRotation } from '@/mutation-types';

const state = {
  pdfId: INIT_NO_OP_NUM,    // id in db
  pdfIndex: INIT_NO_OP_NUM, // id in dropdown list
  pdfRotation: 0,           // rotation in degree: 0, 90, 180, 240
};

const getters = {
  getPdfId: state => state.pdfId,
  getPdfIndex: state => state.pdfIndex,
  getPdfRotation: state => state.pdfRotation,

  /**
   * returns a list of all pdf ids
   */
  getPdfList (state, getters, rootState, rootGetters) {
    // pick id and recordedAt from all data
    let pdfList = [];
    if (rootGetters['login/getAllData'] && rootGetters['login/getAllData'].pdfs) {
      rootGetters['login/getAllData'].pdfs.forEach((pdf,index) => {
        pdfList.push({id:pdf.id, index, recordedAt: pdf.recordedAt, displayName: pdf.recordedAt});
      });
    }
    return pdfList;
  },
  getIndexOfLastPdf (state, getters, rootState) {
    return rootState.login.phrData.pdfs.length-1;
  },
};

const mutations = {
  [setPdf] (state, payload) {
    state.pdfId = parseInt(payload.pdfId);
    state.pdfIndex = parseInt(payload.pdfIndex);
  },
  [clearPdf] (state) {
    state.pdfId = INIT_NO_OP_NUM;
    state.pdfIndex = INIT_NO_OP_NUM;
  },
  [setRotation] (state, payload) {
    state.pdfRotation = parseInt(payload.pdfRotation);
  },
};

const actions = {

  uploadPdf ({commit, state, rootState}, formData) {
    return new Promise((resolve, reject) => {
      if (formData) {
        uploadFile(PDF_FILE_TYPE, formData)
        .then((response) => {
          const responseData = response.data;
          resolve(responseData.id);
        })
        .catch((err) => {
          reject(err);
        });
      } else {
        reject(`Please include a ${PDF_FILE_TYPE} file (in .xml format) you want to upload `);
      }
    });
  },

  async requestPdfById ({state,commit}, id) {
    return new Promise((resolve, reject) => {
      getFileById(PDF_FILE_TYPE, id)
      .then((response) => {
        resolve(response.pdf);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  saveExtraction({commit}, requestParams) {
    return new Promise((resolve, reject) => {
      saveExtractionIntoReport(requestParams)
      .then((response) => {
        // update model
        commit('login/setApplicationModel', response.data, {root: true});
        resolve(response.id);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  clearPdf ({commit}) {
    commit(clearPdf);
  },

  setRotation({state, commit}, requestParams) {
    const {id, rotation} = requestParams;
    commit('setRotation', {id: id, pdfRotation: rotation});
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
